import React from 'react';
import './ProjectDashboardNotif.css';
import ActivityPreview from './ActivityPreview';
import AttendancePreview from './AttendancePreview';
import ProgrammePreview from './ProgrammePreview';
import DesignPreview from './DesignPreview';
import DocumentsPreview from './DocumentsPreview';
import SnagsPreview from './SnagsPreview';

const WhitePanel = ({ title, description, onClick, children, notificationCount = 0, projectId, panelType }) => {
  const handleClick = () => {
    // Always call the original onClick (navigation)
    if (onClick) {
      onClick();
    }
  };

  return (
          <div
        style={{
          background: 'var(--branding-app-surface-panel)',
          color: 'var(--branding-app-surface-panel-fg)',
          borderRadius: '16px',
          padding: '32px',
          marginBottom: '32px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          cursor: 'pointer',
          height: 'clamp(320px, 28vh, 520px)', // Viewport-responsive height
          width: '100%',
          maxWidth: '100%',
          boxSizing: 'border-box',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}
      onClick={handleClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.05)';
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>{title}</h3>
        {notificationCount > 0 && (
          <div
            className="notification-badge"
            title={`${notificationCount} new notification${notificationCount > 1 ? 's' : ''}`}
          >
            {notificationCount > 9 ? '9+' : notificationCount}
          </div>
        )}
      </div>
      
      {/* Activity Preview - Positioned higher up */}
      {projectId && panelType ? (
        <div
          style={{ 
            marginTop: '8px',
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start'
          }}
        >
          {panelType === 'activity' && (
            <ActivityPreview 
              projectId={projectId}
            />
          )}
          {panelType === 'attendance' && (
            <AttendancePreview 
              projectId={projectId}
            />
          )}
          {panelType === 'gantt' && (
            <ProgrammePreview 
              projectId={projectId}
            />
          )}
          {panelType === 'design' && (
            <DesignPreview 
              projectId={projectId}
            />
          )}
          {panelType === 'documents' && (
            <DocumentsPreview 
              projectId={projectId}
            />
          )}
          {panelType === 'snag' && (
            <SnagsPreview 
              projectId={projectId}
            />
          )}
        </div>
      ) : (
        // Placeholder for tiles without activity previews to maintain consistent height
        <div style={{ flex: 1 }} />
      )}
      
      {children && (
        <div
          style={{ marginTop: '16px' }}
          onClick={(e) => e.stopPropagation()} // Prevent click propagation to parent
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default WhitePanel;
